import { Parkinglot, SharedParkinglot } from '@/components/detail/components/shared/parkinglotInfo/model'

export class GetPoisResDto {
  data!: PoiType[]
}

export interface PoiType {
  parkinglots: Parkinglot[] | []
  sharedParkinglots: SharedParkinglot[] | []
  evStations: Parkinglot[] | []
  geohash: string
}
